import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography, makeStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { EmptyTicketIcon } from 'images/svg';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100vh',
    margin: '.3rem 0 1rem 0',
    padding: '1.5rem 1rem',
  },
  title: {
    ...theme.title,
    fontSize: '30px',
    marginBottom: '1rem',
    marginTop: '1.5rem',
  },
  text: {
    margin: '15vh 1vh',
    textAlign: 'center',
  },
  label: {
    fontFamily: ['FuturaStdBook', 'sans-serif'].join(','),
    color: '#262957',
  },
}));
const EmptyList = ({ label }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Grid container className={classes.root}>
      <Grid item className={classes.text}>
        <EmptyTicketIcon />
        <Typography variant="h3" className={classes.title}>
          {t('oupss')}
        </Typography>

        <Typography variant="h6" className={`${classes.label}`}>
          {t(label)}
        </Typography>
      </Grid>
    </Grid>
  );
};

EmptyList.propTypes = {
  label: PropTypes.string.isRequired,
};

export default EmptyList;
